import { render, staticRenderFns } from "./pay-item.vue?vue&type=template&id=06057295&scoped=true&"
import script from "./pay-item.vue?vue&type=script&lang=js&"
export * from "./pay-item.vue?vue&type=script&lang=js&"
import style0 from "./pay-item.vue?vue&type=style&index=0&id=06057295&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06057295",
  null
  
)

export default component.exports